module.exports = __webpack_public_path__ + "static_pc/img/17.2fb848e3.png";